module.exports = __webpack_public_path__ + "img/130.6e1a3591.jpg";